import React, {Component} from 'react';
import _ from 'lodash';
import './CreateAccreditationRequest.css';
import PropTypes from 'prop-types';
import {Utils} from "../../../utils/utils";
import {sharedLabelsPath} from "../../../reducers/common/localization";
import Select from '../../commonComponents/customSelect/CustomSelect.container';
import {FormGroup, Label, Col, Form, Collapse, Input, Button, Row, UncontrolledPopover , PopoverBody} from 'reactstrap'
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import moment from "moment/moment";
import DatePicker from 'react-datepicker';
import AdditionalTitle from './../../accreditationManagement/additionalTitle/AdditionalTitle.container';
import uuid from "uuid";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import AccreditationRequestGetOrgErrorModal from "../accreditationRequestGetOrgErrorModal/AccreditationRequestGetOrgErrorModal.container";
import DomainInput from "../../commonComponents/domainInput/DomainInput";

const requiredSelectFields = ['orgContinent', 'orgCountry', 'orgId', 'accreditationGroupId', 'level', 'VID', 'personContinent', 'personCountry'];

const INPUT_MODE = {
    MANUAL_INPUT: 'manual_input',
    SELECT_INPUT: 'select_input'
};

class CreateAccreditationRequest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orgContinent: '',
            orgCountry: '',
            orgId: '',
            orgDomain: '',
            orgName: '',
            orgInputMode: INPUT_MODE.SELECT_INPUT,
            accreditationGroupName: '',
            accreditationGroupId: '',
            accreditationGroupInputMode: INPUT_MODE.MANUAL_INPUT,
            titleOrig: '',
            titleEn: '',
            titlesAdditional: [],
            dateIssued: moment(),
            level: '',
            VIDInputMode: INPUT_MODE.SELECT_INPUT,
            VID: null,
            personFirstName: '',
            personLastName: '',
            personContinent: this.props.continentCode,
            personCountry: '',
            nationalId: '',
            expose: false,
            requiredFieldError: null,
            accreditationConsent: false,
            hasAccreditationGroups: true,
            orgIdInput: ''
        }
    }

    componentWillMount() {
        this.props.onGetLevels();
        this.props.onGetAdditionalLangs();
        this.props.onGetVIDs();
        this.props.onGetDefaultAlias();
    }

    componentWillUpdate(nextProps, nextState) {
        if (!this.props.AGError && nextProps.AGError === "ORGANIZATION_ACCREDITATION_FLOW_FORBIDDEN") {
            this.props.onOpenErrorModal();
        }

        if (this.state.VIDInputMode === INPUT_MODE.SELECT_INPUT && nextState.VIDInputMode === INPUT_MODE.MANUAL_INPUT && !_.isNil(nextProps.defaultAlias)) {
            this.setState({
                personFirstName: nextProps.defaultAlias.firstName,
                personLastName: nextProps.defaultAlias.lastName,
                personCountry: nextProps.defaultAlias.countryCode
            });
            this.props.onContinentSetByCountry(nextProps.defaultAlias.countryCode);
        }

        if (nextProps.continentCode !== this.props.continentCode) {
            this.setState({personContinent: nextProps.continentCode});
        }

        if (this.state.orgIdInput !== nextState.orgIdInput) {
            this.props.onGetOrganizations(this.state.orgCountry, nextState.orgIdInput);
        }

        if (this.state.orgId !== nextState.orgId && !_.isEmpty(nextState.orgId)) {
            this.props.onGetAccreditationGroups(nextState.orgId);
        }

        if (_.isNil(this.props.orgByDomain) && !_.isNil(nextProps.orgByDomain)) {
            this.setState({
                orgContinent: nextProps.countryByDomain.continent,
                orgCountry: nextProps.countryByDomain.countryCode,
                orgId: nextProps.orgByDomain,
                orgName: nextProps.orgNameByDomain
            });
            this.props.onGetOrganizations(nextProps.countryByDomain.countryCode);
        }

        if (this.state.orgInputMode === INPUT_MODE.SELECT_INPUT && nextState.orgInputMode === INPUT_MODE.MANUAL_INPUT) {
            this.props.resetAccreditationGroups();
        }

        if (_.isNil(this.props.accreditationGroups) && !_.isNil(nextProps.accreditationGroups) && nextProps.accreditationGroups.length !== 0) {
            this.setState({accreditationGroupInputMode: INPUT_MODE.SELECT_INPUT})
        }

        if (!this.props.success && nextProps.success) {
            this.resetData();
        }

        if ((!_.isEqual(this.props.organizations, nextProps.organizations) || !_.isEqual(nextProps.orgByDomain, this.props.orgByDomain)) &&
            !_.isEmpty(nextProps.organizations) && !_.isNil(nextProps.orgByDomain) &&
            _.find(nextProps.organizations, option => option.value === nextProps.orgByDomain)) {
            let org = _.find(nextProps.organizations, option => option.value === nextProps.orgByDomain);
            this.setState({
                orgInputMode: INPUT_MODE.SELECT_INPUT,
                hasAccreditationGroups: org ? !org.bavaManaged : true
            });
        }
    }

    render() {
        return (
            <div className='create-accreditation-request-container'>
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'accreditation_requests.create_accreditation_request_success_message')}>
                    <BackButtonComponent path='/accreditation-requests-list'
                                            label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <h4 className='page-label'>{_.get(this.props.translation, 'accreditation_requests.create_accreditation_request_label')}</h4>
                    {this.renderContent()}
                    <AccreditationRequestGetOrgErrorModal/>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        return (
            <Form className="create-accreditation-request-form" onSubmit={this.handleSubmit}>
                <h5 className="create-accreditation-request-subtitle before-hint olive-green">{_.get(this.props.translation, sharedLabelsPath.org_label)}</h5>
                <div className="organization-hint">
                    {Utils.getTagsFromStringWithStyles(
                        _.get(this.props.translation, 'accreditation_requests.create_accreditation_request_hint')
                    )}
                </div>
                {this.renderMenu('orgInputMode')}
                {this.renderCountrySelect()}
                {this.renderOrgFormGroup()}
                <Collapse isOpen={this.state.orgInputMode === INPUT_MODE.SELECT_INPUT && this.state.hasAccreditationGroups}>
                    <h5 className="create-accreditation-request-subtitle olive-green">{_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}</h5>
                    {this.renderAccreditationGroupFormGroup()}
                </Collapse>
                <h5 className="create-accreditation-request-subtitle olive-green">{_.get(this.props.translation, 'accreditation.accreditation_label')}</h5>
                {this.renderTitlesFormGroups()}
                {this.renderAccreditationFormGroups()}
                {this.renderAdditionalTitlesFormGroups()}
                {this.renderAccreditationCheckboxFormGroup()}
                <h5 className="create-accreditation-request-subtitle olive-green">{_.get(this.props.translation, 'accreditation_requests.vid_label')}</h5>
                {this.renderVIDFormGroup()}
                {this.renderExposeCheckbox()}
                <div className='button-group'>
                    <Button type="submit" className="olive-green-btn">
                        {_.get(this.props.translation, sharedLabelsPath.add_button)}
                    </Button>
                </div>
            </Form>
        )
    };

    renderCountrySelect = () => {
        if (this.state.orgInputMode === INPUT_MODE.SELECT_INPUT) {
            let paramsList = [
                {
                    value: "orgContinent",
                    title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                    type: 'select',
                    content: Utils.getLocationOptions(
                        this.props.continents,
                        _.get(this.props.translation, sharedLabelsPath.continents)
                    ),
                    placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                    isDisabled: !this.props.continents,
                    onChange: this.handleChangeOrgContinent
                },
                {
                    value: "orgCountry",
                    title: _.get(this.props.translation, sharedLabelsPath.country_label),
                    type: 'select',
                    content: Utils.getLocationOptions(
                        this.props.locationData[this.state.orgContinent],
                        _.get(this.props.translation, sharedLabelsPath.countries)
                    ),
                    placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                    isDisabled: !this.props.continents,
                    onChange: this.handleChangeOrgCountry
                }
            ];

            return [..._.map(paramsList, this.getSelectFormGroup)];
        }
    };

    renderOrgFormGroup = () => {
        let selectInputParams = {
            value: "orgId",
            title: _.get(this.props.translation, sharedLabelsPath.org_label),
            content: this.props.organizations || [],
            placeholder: _.get(this.props.translation, _.get(this.props.translation, sharedLabelsPath.org_label)),
            isDisabled: _.isEmpty(this.state.orgCountry) || _.isNil(this.props.organizations) || this.props.loadingOrgByDomain,
            isRequired: this.state.orgInputMode === INPUT_MODE.SELECT_INPUT,
            onInputChange: this.handleSelectInputChange,
            onChange: this.handleChangeOrgId
        };

        let manualInputParamsList = [
            {
                value: "orgContinent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                isDisabled: !this.props.continents,
                isRequired: this.state.orgInputMode === INPUT_MODE.MANUAL_INPUT,
            },
            {
                value: "orgCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.locationData[this.state.orgContinent],
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isDisabled: !this.props.continents,
                isRequired: this.state.orgInputMode === INPUT_MODE.MANUAL_INPUT,
            },
            {
                value: "orgDomain",
                title: _.get(this.props.translation, sharedLabelsPath.domain_label) + '*',
                isRequired: this.state.orgInputMode === INPUT_MODE.MANUAL_INPUT,
                placeholder: _.get(this.props.translation, sharedLabelsPath.domain_label),
                isDisabled: this.props.loadingOrgByDomain,
                onBlur: this.getOrgByDomain,
                popoverHintParams: {
                    hintText: _.get(this.props.translation, 'accreditation_requests.domain_hint')
                }
            },
            {
                value: "orgName",
                title: _.get(this.props.translation, "orgs.name_label"),
                placeholder: _.get(this.props.translation, "orgs.name_label")
            }
        ];

        return (
            <FormGroup>
                <Collapse isOpen={this.state.orgInputMode === INPUT_MODE.SELECT_INPUT}>
                    {this.state.orgInputMode === INPUT_MODE.SELECT_INPUT ? this.getSelectFormGroup(selectInputParams) : null}
                </Collapse>
                <Collapse isOpen={this.state.orgInputMode === INPUT_MODE.MANUAL_INPUT}>
                    {this.state.orgInputMode === INPUT_MODE.MANUAL_INPUT ? [..._.map(manualInputParamsList, this.getFormGroup)] : null}
                </Collapse>
            </FormGroup>
        );
    };

    renderAccreditationGroupFormGroup = () => {
        let selectInputParams = {
            value: "accreditationGroupId",
            title: _.get(this.props.translation, sharedLabelsPath.accreditation_group_label),
            content: this.props.accreditationGroups || [],
            placeholder: _.get(this.props.translation, sharedLabelsPath.accreditation_group_label),
            isDisabled: (_.isEmpty(this.state.orgId) && _.isEmpty(this.state.orgDomain)),
            isRequired: this.state.orgInputMode === INPUT_MODE.SELECT_INPUT && this.state.hasAccreditationGroups
                && this.state.accreditationGroupInputMode === INPUT_MODE.SELECT_INPUT,
            popoverHintParams: {
                hintText: _.get(this.props.translation, 'accreditation_requests.accreditation_group_hint')
            }
        };

        let manualInputParams = {
            value: "accreditationGroupName",
            title: _.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_name_label'),
            isRequired: this.state.orgInputMode === INPUT_MODE.SELECT_INPUT && this.state.hasAccreditationGroups
                && this.state.accreditationGroupInputMode === INPUT_MODE.MANUAL_INPUT,
            placeholder: _.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_name_label'),
            isDisabled: (_.isEmpty(this.state.orgId) && _.isEmpty(this.state.orgDomain)),
            popoverHintParams: {
                hintText: _.get(this.props.translation, 'accreditation_requests.accreditation_group_hint')
            }
        };

        return (
            <FormGroup>
                {this.renderMenu('accreditationGroupInputMode')}
                <Collapse isOpen={this.state.accreditationGroupInputMode === INPUT_MODE.SELECT_INPUT}>
                    {this.state.accreditationGroupInputMode === INPUT_MODE.SELECT_INPUT ? this.getSelectFormGroup(selectInputParams) : null}
                </Collapse>
                <Collapse isOpen={this.state.accreditationGroupInputMode === INPUT_MODE.MANUAL_INPUT}>
                    {this.state.accreditationGroupInputMode === INPUT_MODE.MANUAL_INPUT ? this.getFormGroup(manualInputParams) : null}
                </Collapse>
            </FormGroup>
        );
    };

    renderTitlesFormGroups = () => {
        let paramsList = [
            {
                value: "titleOrig",
                title: _.get(this.props.translation, 'accreditation.accreditation_title_orig_label'),
                isRequired: true,
                placeholder: _.get(this.props.translation, 'accreditation.accreditation_title_orig_input_placeholder')
            },
            {
                value: "titleEn",
                title: _.get(this.props.translation, 'accreditation.accreditation_title_en_label'),
                isRequired: true,
                placeholder: _.get(this.props.translation, 'accreditation.accreditation_title_en_input_placeholder')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderAccreditationFormGroups = () => {
        let params = {
            value: "level",
            title: _.get(this.props.translation, 'accreditation.level_label'),
            isDisabled: _.isNil(this.props.levels),
            content: Utils.getLevelsOptions(
                this.props.levels,
                _.get(this.props.translation, 'levels')
            ),
            placeholder: _.get(this.props.translation, 'accreditation.level_input_placeholder'),
            isRequired: true
        };

        return [this.renderDateIssued(), this.getSelectFormGroup(params)];
    };

    renderAccreditationCheckboxFormGroup = () => {
        return (
            <FormGroup className='checkbox-form-group'>
                <Row className='checkbox-container'>
                    <Label className='checkbox-label'>
                        <Input type="checkbox" checked={this.state.accreditationConsent}
                               required
                               onChange={this.toggleConsentCheckbox}/>
                        {_.get(this.props.translation, 'accreditation_requests.applicant_accreditation_consent_label')}
                    </Label>
                </Row>
            </FormGroup>
        )
    }

    toggleConsentCheckbox = () => {
        this.setState({accreditationConsent: !this.state.accreditationConsent});
    };

    renderAdditionalTitlesFormGroups = () => {
        let title = (
            <h6 className="additional-langs-title" key="additional-langs-title">
                <span> {_.get(this.props.translation, 'accreditation.additional_translations_label')}</span>
                <IconContainer
                    className="add-additional-lang-icon olive-green"
                    icon="add"
                    onClick={this.addAdditionalTitle}
                    title={_.get(this.props.translation, 'accreditation.add_additional_translations_label')}
                />
            </h6>
        );
        let result = [title];

        this.state.titlesAdditional.forEach((elem) => {
            result.push(
                <AdditionalTitle
                    key={elem.id}
                    id={elem.id}
                    lang={elem.lang}
                    title={elem.title}
                    langs={this.getAvailableLang(elem.id)}
                    onChangeLang={this.handleChangeAdditionalTitleLang}
                    onChangeTitle={this.handleChangeAdditionalTitle}
                    onRemove={this.removeAdditionalTitle}
                    required
                    requiredFieldError={this.state.requiredFieldError === elem.id}
                />
            );
        });

        return result;
    };

    renderDateIssued = () => {
        return (
            <FormGroup row key='date-issued'>
                <Label for='date-issued'
                       sm={3}>{_.get(this.props.translation, 'accreditation.date_issued_label')}*</Label>
                <Col sm={9}>
                    <DatePicker
                        customInput={<Input
                            id='date-issued'
                        />}
                        selected={this.state.dateIssued}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        required
                        onChange={this.handleChangeDate}
                        maxDate={moment()}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderVIDFormGroup = () => {
        let selectInputParams = {
            value: "VID",
            title: _.get(this.props.translation, 'accreditation_requests.vid_label'),
            content: Utils.getOptions(
                _.map(this.props.VIDs, VID => ({
                    code: VID.id,
                    name: VID.firstName + ' ' + VID.lastName + ', ' + VID.nationalId
                }))
            ),
            placeholder: _.get(this.props.translation, 'accreditation_requests.vid_label'),
            isDisabled: _.isNil(this.props.VIDs),
            isRequired: this.state.VIDInputMode === INPUT_MODE.SELECT_INPUT,
            menuPlacement: 'top'
        };

        let manualInputParamsList = [
            {
                value: "personFirstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            },
            {
                value: "personLastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            },
            {
                value: "nationalId",
                title: _.get(this.props.translation, sharedLabelsPath.national_id_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.national_id_label),
                popoverHintParams: {
                    hintText: _.get(this.props.translation, 'accreditation_requests.national_id_hint')
                }
            },
            {
                value: "personContinent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                onChange: this.handleChangeContinent,
                isRequired: true,
                isDisabled: !this.props.continents,
                menuPlacement: 'top'
            },
            {
                value: "personCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isRequired: true,
                isDisabled: !this.props.countries,
                menuPlacement: 'top'
            }
        ];

        let emailParams = {
            value: this.props.email,
            title: _.get(this.props.translation, sharedLabelsPath.email_label)
        };

        return (
            <FormGroup>
                {this.renderMenu('VIDInputMode')}
                <Collapse isOpen={this.state.VIDInputMode === INPUT_MODE.SELECT_INPUT}>
                    {this.state.VIDInputMode === INPUT_MODE.SELECT_INPUT ? this.getSelectFormGroup(selectInputParams) : null}
                </Collapse>
                <Collapse isOpen={this.state.VIDInputMode === INPUT_MODE.MANUAL_INPUT}>
                    {this.state.VIDInputMode === INPUT_MODE.MANUAL_INPUT ? [..._.map(manualInputParamsList, this.getFormGroup)] : null}
                </Collapse>
                {this.getDataRow(emailParams)}
            </FormGroup>
        );
    };

    renderMenu = (fieldKey) => {
        return (
            <div className="input-mode-menu">
                <div
                    className={"input-mode-icon-container" + ((this.state[fieldKey] === INPUT_MODE.SELECT_INPUT) ? " olive-green" : "")}
                    onClick={this.handleToggleMenu(fieldKey, INPUT_MODE.SELECT_INPUT)}>
                    <IconContainer
                        className="input-mode-icon"
                        icon={"radio_button_" + ((this.state[fieldKey] === INPUT_MODE.SELECT_INPUT) ? "checked" : "unchecked")}
                        title={_.get(this.props.translation, 'request_credentials_verification.manual_input_label')}
                    />
                    {_.get(this.props.translation, 'accreditation_requests.select_' + _.snakeCase(fieldKey) + '_label')}
                </div>
                <div
                    className={"input-mode-icon-container" + ((this.state[fieldKey] === INPUT_MODE.MANUAL_INPUT) ? " olive-green" : "")}
                    onClick={this.handleToggleMenu(fieldKey, INPUT_MODE.MANUAL_INPUT)}>
                    <IconContainer
                        className="input-mode-icon"
                        icon={"radio_button_" + ((this.state[fieldKey] === INPUT_MODE.MANUAL_INPUT) ? "checked" : "unchecked")}
                        title={_.get(this.props.translation, 'request_credentials_verification.upload_file_label')}
                    />
                    {_.get(this.props.translation, 'accreditation_requests.manual_' + _.snakeCase(fieldKey) + '_label')}
                </div>
            </div>
        );
    };

    getDataRow = (params) => {
        return (
            <Row className='org-settings-row' key={params.title}>
                <Col sm={3}>{params.title}:</Col>
                <Col>{params.value}</Col>
            </Row>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderHintPopover(params.value, params.popoverHintParams)}
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange || this.handleChangeSelect(params.value)}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            isSearchable={true}
                            menuPlacement={params.menuPlacement}
                            requiredFieldError={params.isRequired && this.state.requiredFieldError === params.value}
                            onInputChange={params.onInputChange}
                    />
                </Col>
            </FormGroup>
        );
    };

    getFormGroup = (params) => {
        if (params.type === 'dataRow') {
            return this.getDataRow(params)
        }

        if (params.value === 'orgDomain') {
            return this.getOrganizationDomainFormGroup(params);
        }

        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }

        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderHintPopover(params.value, params.popoverHintParams)}
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={_.get(this.state, params.value)}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                           onBlur={params.onBlur}>
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    getOrganizationDomainFormGroup = (params) => {
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <DomainInput id={id}
                                 value={this.state[params.value]}
                                 onChange={this.handleChangeDomainInput}
                                 onBlur={params.onBlur}
                                 placeholder={params.placeholder || params.title}
                                 disabled={params.isDisabled}
                                 required={params.isRequired}/>
                </Col>
            </FormGroup>
        );
    };

    renderHintPopover = (fieldName, params) => {
        if (!_.isNil(params)) {
            return (
                <div className="hint-container">
                    <span id={fieldName + '-hint'} className='hint-icon-container'>
                        <IconContainer icon='question_mark'
                                       title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                    </span>
                    <UncontrolledPopover trigger="legacy" placement="bottom" target={fieldName + '-hint'}>
                        <PopoverBody>
                            <div>
                                {Utils.getTagsFromStringWithStyles(params.hintText)}
                            </div>
                        </PopoverBody>
                    </UncontrolledPopover >
                </div>
            );
        }
    };

    handleToggleMenu = (fieldKey, value) => () => {
        switch (fieldKey) {
            case 'orgInputMode':
                this.props.resetOrganization();
                this.setState({
                    [fieldKey]: value,
                    orgId: '',
                    orgContinent: '',
                    orgCountry: '',
                    orgDomain: '',
                    orgName: '',
                    requiredFieldError: null
                });
                break;
            case 'accreditationGroupInputMode':
                this.setState({
                    [fieldKey]: value,
                    accreditationGroupName: '',
                    accreditationGroupId: '',
                    requiredFieldError: null
                });
                break;
            case 'VIDInputMode':
                this.setState({
                    [fieldKey]: value,
                    VID: null,
                    requiredFieldError: null,
                    firstName: '',
                    lastName: '',
                    personContinent: this.props.continentCode,
                    personCountry: '',
                    nationalId: '',
                });
                break;
            default:
                break;
        }
    };

    renderExposeCheckbox = () => {
        return (
            <FormGroup className='checkbox-form-group'>
                <Row className='checkbox-container'>
                    <Label className='checkbox-label'>
                        <Input type="checkbox" checked={this.state.expose}
                               onChange={this.toggleExposeCheckbox}/>
                        {_.get(this.props.translation, 'accreditation_requests.expose_accreditation_request_label')}
                    </Label>
                    <span id='create-accreditation-request-expose-icon-container'
                          className='create-accreditation-request-expose-icon-container'>
                            <IconContainer icon='question_mark'
                                           title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                        </span>
                    <UncontrolledPopover placement="bottom" trigger="legacy"
                                         target="create-accreditation-request-expose-icon-container">
                        <PopoverBody>
                            {_.get(this.props.translation, 'accreditation_requests.expose_hint')}
                        </PopoverBody>
                    </UncontrolledPopover>
                </Row>
            </FormGroup>
        )
    };

    handleChangeDate = (date) => {
        this.setState({dateIssued: date});
    };

    toggleExposeCheckbox = () => {
        this.setState({expose: !this.state.expose});
    };

    handleChangeOrgId = (selectedOption) => {
        this.setState({
            orgId: selectedOption.value,
            hasAccreditationGroups: !selectedOption.bavaManaged
        })
    };

    handleChangeOrgContinent = (selectedOption) => {
        this.setState({
            orgContinent: selectedOption.value,
            orgCountry: '',
            orgId: '',
            hasAccreditationGroups: true
        });
        this.props.resetOrganizations();
    };

    handleChangeOrgCountry = (selectedOption) => {
        this.setState({
            orgCountry: selectedOption.value,
            orgId: '',
            hasAccreditationGroups: true
        });
        if (this.state.orgName !== '') {
            this.props.onGetOrganizations(selectedOption.value, this.state.orgName);
        } else {
            this.props.onGetOrganizations(selectedOption.value);
        }
    };

    handleChangeSelect = (fieldKey) => (selectedOption) => {
        this.setState({[fieldKey]: selectedOption.value});
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeDomainInput = (data) => {
        this.setState({orgDomain: data});
    };

    handleChangeAdditionalTitle = (id) => (e) => {
        let newTitles = this.state.titlesAdditional.map((elem) => {
            if (elem.id === id) elem.title = e.target.value;
            return elem;
        });

        this.setState({titlesAdditional: newTitles});
    };

    handleChangeAdditionalTitleLang = (id, value) => {
        let newTitles = this.state.titlesAdditional.map((elem) => {
            if (elem.id === id) elem.lang = value;
            return elem;
        });

        this.setState({titlesAdditional: newTitles});
    };

    handleChangeContinent = (selectedOption) => {
        this.setState({personCountry: ''});
        this.props.onContinentSet(selectedOption.value);
    };

    addAdditionalTitle = () => {
        let newTitle = {
            id: uuid(),
            lang: '',
            title: ''
        };

        this.setState({titlesAdditional: [...this.state.titlesAdditional, newTitle]});
    };

    removeAdditionalTitle = (id) => () => {
        let newTitles = this.state.titlesAdditional.filter((elem) => elem.id !== id);

        this.setState({titlesAdditional: newTitles});
    };

    getAvailableLang(id) {
        let disabledLangs = this.state.titlesAdditional.filter(elem => elem.id !== id).map(elem => elem.lang);

        return _.values(this.props.additionalLangs).filter(lang => !disabledLangs.includes(lang));
    };

    getOrgByDomain = (data) => {
        this.setState({orgDomain: data}, () => {
            this.props.onGetOrgByDomain(this.state.orgDomain);
            this.setState({
                orgId: ''
            });
        });
    };

    handleSelectInputChange = (value) => {
        this.setState({orgIdInput: value});
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
             return;
        }

        let titles = {
            original: this.state.titleOrig,
            en: this.state.titleEn
        };

        this.state.titlesAdditional.forEach(elem => {
            if (elem.lang !== "") titles[elem.lang] = elem.title;
        });

        let data = {
            accreditationData: {
                titles: titles,
                issuedAt: this.state.dateIssued.format("YYYY-MM-DD"),
                level: this.state.level
            },
            expose: this.state.expose
        };

        switch (this.state.orgInputMode) {
            case INPUT_MODE.MANUAL_INPUT:
                data.orgDomain = this.state.orgDomain;
                data.orgName = this.state.orgName;
                data.countryCode = this.state.orgCountry;
                break;
            case INPUT_MODE.SELECT_INPUT:
                data.orgId = this.state.orgId;
                break;
            default:
                break;
        }

        switch (this.state.accreditationGroupInputMode) {
            case INPUT_MODE.MANUAL_INPUT:
                data.accreditationGroupName = this.state.accreditationGroupName;
                break;
            case INPUT_MODE.SELECT_INPUT:
                data.accreditationGroupId = this.state.accreditationGroupId;
                break;
            default:
                break;
        }

        switch (this.state.VIDInputMode) {
            case INPUT_MODE.SELECT_INPUT:
                data.verifiedIdentity = _.find(this.props.VIDs, vid => vid.id === this.state.VID);
                break;
            case INPUT_MODE.MANUAL_INPUT:
                data.verifiedIdentity = {
                    firstName: this.state.personFirstName,
                    lastName: this.state.personLastName,
                    countryCode: this.state.personCountry,
                    nationalId: this.state.nationalId
                };
                break;
            default:
                break;
        }

        this.props.onCreate(data);
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                switch (field) {
                    case 'orgContinent':
                        if (this.state.orgInputMode === INPUT_MODE.MANUAL_INPUT) {
                            error = field;
                        }
                        break;
                    case 'orgCountry':
                        if (this.state.orgInputMode === INPUT_MODE.MANUAL_INPUT) {
                            error = field;
                        }
                        break;
                    case 'orgId':
                        if (this.state.orgInputMode === INPUT_MODE.SELECT_INPUT) {
                            error = field;
                        }
                        break;
                    case 'accreditationGroupId':
                        if (this.state.orgInputMode === INPUT_MODE.SELECT_INPUT && this.state.hasAccreditationGroups &&
                            this.state.accreditationGroupInputMode === INPUT_MODE.SELECT_INPUT) {
                            error = field;
                        }
                        break;
                    case 'VID':
                        if (this.state.VIDInputMode === INPUT_MODE.SELECT_INPUT) {
                            error = field;
                        }
                        break;
                    case 'personCountry':
                        if (this.state.VIDInputMode === INPUT_MODE.MANUAL_INPUT) {
                            error = field;
                        }
                        break;
                    case 'personContinent':
                        if (this.state.VIDInputMode === INPUT_MODE.MANUAL_INPUT) {
                            error = field;
                        }
                        break;
                    default:
                        error = field;
                        break;
                }
            }
        });
        _.map(this.state.titlesAdditional, title => {
            if (title.lang === '' && !error) {
                error = title.id;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    };

    resetData = () => {
        this.setState({
            orgCountry: '',
            orgId: '',
            orgDomain: '',
            orgName: '',
            orgInputMode: INPUT_MODE.SELECT_INPUT,
            accreditationGroupName: '',
            accreditationGroupId: '',
            accreditationGroupInputMode: INPUT_MODE.MANUAL_INPUT,
            titleOrig: '',
            titleEn: '',
            titlesAdditional: [],
            dateIssued: moment(),
            level: '',
            VIDInputMode: INPUT_MODE.SELECT_INPUT,
            VID: null,
            personFirstName: '',
            personLastName: '',
            personContinent: this.props.continentCode,
            personCountry: '',
            nationalId: '',
            expose: false,
            requiredFieldError: null,
            hasAccreditationGroups: true
        });
    }
}

CreateAccreditationRequest.propTypes = {
    translation: PropTypes.object,
    additionalLangs: PropTypes.array,
    levels: PropTypes.array,
    VIDs: PropTypes.array,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    email: PropTypes.string,
    defaultAlias: PropTypes.object,
    organizations: PropTypes.array,
    accreditationGroups: PropTypes.array,
    orgByDomain: PropTypes.string,
    countryByDomain: PropTypes.object,
    orgNameByDomain: PropTypes.string,
    loadingOrgByDomain: PropTypes.bool,
    AGError: PropTypes.string,
    onGetAdditionalLangs: PropTypes.func.isRequired,
    onGetLevels: PropTypes.func.isRequired,
    onGetVIDs: PropTypes.func.isRequired,
    onContinentSet: PropTypes.func.isRequired,
    onCreate: PropTypes.func.isRequired,
    onGetDefaultAlias: PropTypes.func.isRequired,
    onContinentSetByCountry: PropTypes.func.isRequired,
    onGetOrganizations: PropTypes.func.isRequired,
    onGetAccreditationGroups: PropTypes.func.isRequired,
    onGetOrgByDomain: PropTypes.func.isRequired,
    resetAccreditationGroups: PropTypes.func.isRequired,
    resetOrganization: PropTypes.func.isRequired,
    onOpenErrorModal: PropTypes.func.isRequired,
    resetOrganizations: PropTypes.func.isRequired
};

export default CreateAccreditationRequest;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/createAccreditationRequest/CreateAccreditationRequest.js